'use client';

import { useTranslations } from 'next-intl';
import { MdInfoOutline } from 'react-icons/md';
import { Button } from '@/components/ui/button/Button';
import { ButtonSize, ButtonVariant } from '@/components/ui/button/Button.types';
import { cn } from '@/lib/styleUtils';
import { useAppReleaseStore } from '@/stores/app-release.store';
import {
  bannerButton,
  bannerIcon,
  bannerMessage,
  bannerWrapper,
} from './ReleaseRefreshBanner.style';
import type { ReleaseRefreshBannerProps } from './ReleaseRefreshBanner.types';

export const ReleaseRefreshBanner = ({ className }: ReleaseRefreshBannerProps) => {
  const t = useTranslations('Common');
  const needsRefresh = useAppReleaseStore((state) => state.needsRefresh);
  const refreshNow = useAppReleaseStore((state) => state.refreshNow);

  if (!needsRefresh) return null;

  return (
    <output
      className={cn(bannerWrapper, className)}
      aria-live="polite"
      data-cy="release-refresh-banner"
    >
      <MdInfoOutline className={bannerIcon} aria-hidden="true" />
      <p className={bannerMessage} data-cy="release-refresh-banner-message">{t('releaseUpdateAvailable')}</p>
      <Button
        variant={ButtonVariant.warn}
        size={ButtonSize.small}
        className={bannerButton}
        onClick={refreshNow}
        data-cy="release-refresh-banner-button"
      >
        {t('refresh')}
      </Button>
    </output>
  );
};
